import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

export interface Notificacion {
  id: number;
  message: string;
  url: string;
  payload: any;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}


@Injectable({
  providedIn: 'root'
})
export class NotificacionService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'notificaciones'); // La URL base para el servicio de usuarios
  }

  deleteById(
    id: number,
    trackLoading: boolean = true,
  ): Observable<void> {
    return this.delete<void>('?id='+String(id), undefined, undefined, trackLoading);
  }

  /**
   * DELETE /usuarios/:usuarioId/notificaciones  (soft delete en lote por usuario)
   * Este endpoint NO cuelga de /notificaciones, así que usamos HttpClient directo.
   */
  deleteByUsuario(
    usuarioId: string,
    tipo: string,
    trackLoading: boolean = true,
  ): Observable<void> {    

    return this.delete<void>('?usuario_id='+String(usuarioId)+'&tipo='+String(tipo), undefined, undefined, trackLoading);
  }



}